class Donut {

    /**
     * Constructor
     * @param donutContainer
     * @param percent
     */
    constructor(donutContainer, percent) {
        /**
         * @type Element
         */
        this.donutContainer = donutContainer;
        /**
         * @type {string}
         */
        this.percent = percent || this.donutContainer.getAttribute('data-donut') || 0;
        /**
         * @type {Element}
         */
        this.circle = donutContainer.querySelector('circle');
        /**
         *
         * @type {Element}
         */
        this.number = donutContainer.querySelector('.number-donut');
        /**
         * Animate
         */
        this._donutAnimation();
    }

    /**
     * Animate svg
     * @private
     */
    _donutAnimation() {
        this.number && (this.number.textContent = this.percent);
        this.circle.style.strokeDasharray = this.percent + ', 100';
        this.donutContainer.title += ((this.donutContainer.title) ? ' - ' : '') + this.percent + '%';
    }
}